import { render } from "./Production.vue?vue&type=template&id=02b21a21&scoped=true"
import script from "./Production.vue?vue&type=script&lang=js"
export * from "./Production.vue?vue&type=script&lang=js"

import "./Production.vue?vue&type=style&index=0&id=02b21a21&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b21a21"]])

export default __exports__